<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <VehicleRuleDetails slot-scope="{data}" :rule-list="data" @refresh="$refs.cache.retry()"></VehicleRuleDetails>
  </l-cache>
</template>
<script>
  import VehicleRuleDetails from './vehicleRuleDetails'
  export default {
    name: 'vehicleRuleDetailsBox',
    components: {VehicleRuleDetails},
    methods: {
      async getItem (key) {
       /* let filter = [
          {key:'ownerType',value:''}
        ]
        let pagination = {
          page:1,
          rowsPerPage:10
        }
        let {items,amount} = await this.$store.dispatch('passControl/getRules',{pagination,filter:filter, search:{key:"ownerId",value:this.$route.query.id}})*/
        let {items} = await this.$store.dispatch('passControl/getAllPassRule',this.$route.query.id)
        console.log(items)
       return items
      }
    }
  }
</script>

